import { render, staticRenderFns } from "./book-edit.component.vue?vue&type=template&id=2763ab30&scoped=true"
import script from "./book-edit.component.vue?vue&type=script&lang=ts"
export * from "./book-edit.component.vue?vue&type=script&lang=ts"
import style0 from "./book.style.scss?vue&type=style&index=0&id=2763ab30&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763ab30",
  null
  
)

export default component.exports